"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var utils_1 = require("@prezzee/utils");
var portal_1 = __importDefault(require("@prezzee/portal"));
var ModalManager_1 = __importStar(require("./ModalManager"));
var trap_focus_1 = __importDefault(require("@prezzee/trap-focus"));
function getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var defaultManager = new ModalManager_1.default();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */
var ModalUnstyled = (0, react_1.forwardRef)(function (props, ref) {
    var BackdropComponent = props.BackdropComponent, BackdropProps = props.BackdropProps, children = props.children, className = props.className, _a = props.closeAfterTransition, closeAfterTransition = _a === void 0 ? false : _a, _b = props.component, component = _b === void 0 ? 'div' : _b, _c = props.components, components = _c === void 0 ? {} : _c, _d = props.componentsProps, componentsProps = _d === void 0 ? {} : _d, container = props.container, _e = props.disableAutoFocus, disableAutoFocus = _e === void 0 ? false : _e, _f = props.disableEnforceFocus, disableEnforceFocus = _f === void 0 ? false : _f, _g = props.disableEscapeKeyDown, disableEscapeKeyDown = _g === void 0 ? false : _g, _h = props.disablePortal, disablePortal = _h === void 0 ? false : _h, _j = props.disableRestoreFocus, disableRestoreFocus = _j === void 0 ? false : _j, _k = props.disableScrollLock, disableScrollLock = _k === void 0 ? false : _k, _l = props.hideBackdrop, hideBackdrop = _l === void 0 ? false : _l, _m = props.keepMounted, keepMounted = _m === void 0 ? false : _m, 
    // private
    // @ts-ignore
    _o = props.manager, 
    // private
    // @ts-ignore
    manager = _o === void 0 ? defaultManager : _o, onClose = props.onClose, onKeyDown = props.onKeyDown, open = props.open, onTransitionEnter = props.onTransitionEnter, onTransitionExited = props.onTransitionExited, other = __rest(props, ["BackdropComponent", "BackdropProps", "children", "className", "closeAfterTransition", "component", "components", "componentsProps", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onClose", "onKeyDown", "open", "onTransitionEnter", "onTransitionExited"]);
    var _p = __read((0, react_1.useState)(true), 2), exited = _p[0], setExited = _p[1];
    var modal = (0, react_1.useRef)({});
    var mountNodeRef = (0, react_1.useRef)(null);
    var modalRef = (0, react_1.useRef)(null);
    var handleRef = (0, utils_1.useForkRef)(modalRef, ref);
    var hasTransition = getHasTransition(props);
    var getDoc = function () { return (0, utils_1.ownerDocument)(mountNodeRef.current); };
    var getModal = function () {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function () {
        manager.mount(getModal(), { disableScrollLock: disableScrollLock });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current)
            modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, utils_1.useEventCallback)(function () {
        var resolvedContainer = getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) {
            handleMounted();
        }
    });
    var isTopModal = (0, react_1.useCallback)(function () { return manager.isTopModal(getModal()); }, [manager]);
    var handlePortalRef = (0, utils_1.useEventCallback)(function (node) {
        mountNodeRef.current = node;
        if (!node) {
            return;
        }
        if (open && isTopModal()) {
            handleMounted();
        }
        else {
            (0, ModalManager_1.ariaHidden)(modalRef.current, true);
        }
    });
    var handleClose = (0, react_1.useCallback)(function () {
        manager.remove(getModal());
    }, [manager]);
    (0, react_1.useEffect)(function () {
        return function () {
            handleClose();
        };
    }, [handleClose]);
    (0, react_1.useEffect)(function () {
        if (open) {
            handleOpen();
        }
        else if (!hasTransition || !closeAfterTransition) {
            handleClose();
        }
    }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
    if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
    }
    var handleEnter = function () {
        setExited(false);
        if (onTransitionEnter) {
            onTransitionEnter();
        }
    };
    var handleExited = function () {
        setExited(true);
        if (onTransitionExited) {
            onTransitionExited();
        }
        if (closeAfterTransition) {
            handleClose();
        }
    };
    var handleBackdropClick = function (event) {
        if (event.target !== event.currentTarget) {
            return;
        }
        if (onClose) {
            onClose(event, 'backdropClick');
        }
    };
    var handleKeyDown = function (event) {
        if (onKeyDown) {
            onKeyDown(event);
        }
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== 'Escape' || !isTopModal()) {
            return;
        }
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) {
                onClose(event, 'escapeKeyDown');
            }
        }
    };
    var childProps = {};
    if (children.props.tabIndex === undefined) {
        childProps.tabIndex = '-1';
    }
    // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, utils_1.createChainedFunction)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, utils_1.createChainedFunction)(handleExited, children.props.onExited);
    }
    var Root = components.Root || component;
    var rootProps = componentsProps.root || {};
    return ((0, jsx_runtime_1.jsx)(portal_1.default, __assign({ ref: handlePortalRef, container: container, disablePortal: disablePortal }, { children: (0, jsx_runtime_1.jsxs)(Root, __assign({ role: "presentation" }, rootProps, other, { ref: handleRef, onKeyDown: handleKeyDown, className: className }, { children: [!hideBackdrop && BackdropComponent ? ((0, jsx_runtime_1.jsx)(BackdropComponent, __assign({ "aria-hidden": true, open: open, onClick: handleBackdropClick }, BackdropProps))) : null, (0, jsx_runtime_1.jsx)(trap_focus_1.default, __assign({ disableEnforceFocus: disableEnforceFocus, disableAutoFocus: disableAutoFocus, disableRestoreFocus: disableRestoreFocus, isEnabled: isTopModal, open: open }, { children: (0, react_1.cloneElement)(children, childProps) }))] })) })));
});
exports.default = ModalUnstyled;
//# sourceMappingURL=ModalUnstyled.js.map